module.exports = __webpack_public_path__ + "img/3242033.svg";